import $ from 'jquery'
import 'core-js/stable'
import 'regenerator-runtime/runtime'

import './component.scss'

import { getCitiesWithMajorByPrefecture } from 'Packs/src/subsidies/api/getCitiesWithMajorByPrefecture'

// ルートクラス定義
const ROOT_TARGET_CLASS_NAME = 'js-topSearchWidget-root-target'
const ROOT_TARGET_SELECTOR = `.${ROOT_TARGET_CLASS_NAME}`

const activateSubmit = () => {
  // セレクタ定義
  const AREA_INPUT_ROOT_TARGET_CLASS_NAME = 'js-topSearchWidget-activateSubmit-areaInput-root-target'
  const AREA_INPUT_ROOT_TARGET_SELECTOR = `.${AREA_INPUT_ROOT_TARGET_CLASS_NAME}`

  const AREA_INPUT_TARGET_CLASS_NAME = 'js-topSearchWidget-activateSubmit-areaInput-target'
  const AREA_INPUT_TARGET_SELECTOR = `.${AREA_INPUT_TARGET_CLASS_NAME}`

  const CONSTRUCTION_PARTS_INPUT_ROOT_TARGET_CLASS_NAME = 'js-topSearchWidget-activateSubmit-constructionPartsInput-root-target'
  const CONSTRUCTION_PARTS_INPUT_ROOT_TARGET_SELECTOR = `.${CONSTRUCTION_PARTS_INPUT_ROOT_TARGET_CLASS_NAME}`

  const CONSTRUCTION_PARTS_INPUT_TARGET_CLASS_NAME = 'js-topSearchWidget-activateSubmit-constructionPartsInput-target'
  const CONSTRUCTION_PARTS_INPUT_TARGET_SELECTOR = `.${CONSTRUCTION_PARTS_INPUT_TARGET_CLASS_NAME}`

  const BUTTON_TARGET_CLASS_NAME = 'js-topSearchWidget-activateSubmit-button-target'
  const BUTTON_TARGET_SELECTOR = `.${BUTTON_TARGET_CLASS_NAME}`

  // アクティブ状態のクラス定義
  const ACTIVE_CLASS_NAME = 'is-active'

  // 処理
  const $rootElement = $(ROOT_TARGET_SELECTOR)

  $rootElement.each((index, root) => {
    const $submitButton = $(root).find(BUTTON_TARGET_SELECTOR)
    const $areaInputRoot = $(root).find(AREA_INPUT_ROOT_TARGET_SELECTOR)
    const $constructionPartsInputRoot = $(root).find(CONSTRUCTION_PARTS_INPUT_ROOT_TARGET_SELECTOR)

    // ボタン活性化判定処理
    const determinationOfActivation = () => {
      const areaValueArray = $.map($areaInputRoot, (areaInputRoot) => {
        const $areaInput = $(areaInputRoot).find(AREA_INPUT_TARGET_SELECTOR)
        return $.map($areaInput, (areaInput) => {
          return $(areaInput).val()
        })
      }).filter((value) => value)

      const constructionPartsValueArray = $.map($constructionPartsInputRoot, (constructionPartsInputRoot) => {
        const $constructionPartsInput = $(constructionPartsInputRoot).find(`${CONSTRUCTION_PARTS_INPUT_TARGET_SELECTOR}:checked`)
        return $.map($constructionPartsInput, (constructionPartsInput) => {
          return $(constructionPartsInput).val()
        })
      }).filter((value) => value)

      if (areaValueArray.length > 0 || constructionPartsValueArray.length > 0) {
        $submitButton.addClass(ACTIVE_CLASS_NAME)
      } else {
        $submitButton.removeClass(ACTIVE_CLASS_NAME)
      }
    }

    // イベント登録
    $areaInputRoot.each((index, areaInputRoot) => {
      const $areaInput = $(areaInputRoot).find(AREA_INPUT_TARGET_SELECTOR)

      $areaInput.on('change', determinationOfActivation)
    })

    $constructionPartsInputRoot.each((index, constructionPartsInputRoot) => {
      const $constructionPartsInput = $(constructionPartsInputRoot).find(CONSTRUCTION_PARTS_INPUT_TARGET_SELECTOR)

      $constructionPartsInput.on('change', determinationOfActivation)
    })

    // 初期値判定
    determinationOfActivation()
  })
}

const updateCity = () => {
  // セレクタ定義
  const TRIGGER_CLASS_NAME = 'js-topSearchWidget-updateCity-trigger'
  const TRIGGER_SELECTOR = `.${TRIGGER_CLASS_NAME}`

  const TARGET_CLASS_NAME = 'js-topSearchWidget-updateCity-target'
  const TARGET_SELECTOR = `.${TARGET_CLASS_NAME}`

  // 処理
  const $rootElement = $(ROOT_TARGET_SELECTOR)

  $rootElement.each((index, root) => {
    const $updateCityTrigger = $(root).find(TRIGGER_SELECTOR)
    const $updateCityTarget = $(root).find(TARGET_SELECTOR)

    $updateCityTrigger.on('change', (event) => {
      const $currentTrigger = $(event.currentTarget)
      const prefectureName = $currentTrigger.find('option:selected').text()

      // 市区町村のセレクトボックスをリセット
      $updateCityTarget.parent().removeClass('is-done') // 完了状態のリセット
      $updateCityTarget.addClass('is-untouched') // ブランク状態に戻す
      $updateCityTarget.val('') // valueをリセット
      $updateCityTarget.html('') // optionタグをリセット
      $updateCityTarget.append('<option value="">市区町村を選択</option>')

      // 市区町村の更新
      $updateCityTarget.prop('disabled', true) // 更新が終わるまで非活性化
      getCitiesWithMajorByPrefecture(prefectureName, (cities) => {
        const kanaGroupData = []

        // ヨミガナの配列を作成、重複を削除して返却値の配列に値を格納
        const kanaList = []
        cities.forEach((city) => {
          kanaList.push(city.yomi.slice(0, 1))
        })
        kanaList
          .filter((x, i) => kanaList.indexOf(x) === i)
          .forEach((kana) => {
            kanaGroupData.push({ kana, cities: [] })
          })

        // ヨミガナの配列から先頭文字を判定し新たな配列を作成
        kanaGroupData.forEach((item) => {
          cities.forEach((city) => {
            if (item.kana === city.yomi.slice(0, 1)) {
              item.cities.push(city)
            }
          })
        })

        const optgroups = $.map(kanaGroupData, (data) => {
          return `<optgroup label="${data.kana}">${$.map(data.cities, (city) => `<option value="${city.id}">${city.name}</option>`).join('')}</optgroup>`
        }).join('')

        $updateCityTarget.append(optgroups)

        if (gon.city_id_for_top_search_widget) {
          const $selectedCity = $updateCityTarget.find(`option[value="${gon.city_id_for_top_search_widget}"]`)
          // 市区町村がない場合は処理を終了
          if ($selectedCity.length === 0) {
            $updateCityTarget.prop('disabled', false) // 処理が終わったら活性化
            return
          }

          $selectedCity.prop('selected', true)
          $updateCityTarget.parent().addClass('is-done') // 完了状態の追加
          $updateCityTarget.removeClass('is-untouched') // ブランク状態の解除

          // gonの値をリセット
          gon.city_id_for_top_search_widget = null
        }

        $updateCityTarget.prop('disabled', false) // 処理が終わったら活性化
      })
    })
  })
}

// 市区町村の初期値設定
const setCities = () => {
  const $rootElement = $(ROOT_TARGET_SELECTOR)

  const TRIGGER_CLASS_NAME = 'js-topSearchWidget-updateCity-trigger'
  const TRIGGER_SELECTOR = `.${TRIGGER_CLASS_NAME}`

  $rootElement.find(TRIGGER_SELECTOR).trigger('change')
}

const switchSearchWidgetDisplay = () => {
  // セレクタ定義
  const OPEN_TRIGGER_CLASS_NAME = 'js-topSearchWidget-switchSearchWidgetDisplay-open-trigger'
  const OPEN_TRIGGER_SELECTOR = `.${OPEN_TRIGGER_CLASS_NAME}`

  const CLOSE_TRIGGER_CLASS_NAME = 'js-topSearchWidget-switchSearchWidgetDisplay-close-trigger'
  const CLOSE_TRIGGER_SELECTOR = `.${CLOSE_TRIGGER_CLASS_NAME}`

  const MODAL_OVERLAY_TARGET_CLASS_NAME = 'js-topSearchWidget-switchSearchWidgetDisplay-modalOverlay-target'
  const MODAL_OVERLAY_TARGET_SELECTOR = `.${MODAL_OVERLAY_TARGET_CLASS_NAME}`

  const MODAL_CONTENTS_TARGET_CLASS_NAME = 'js-topSearchWidget-switchSearchWidgetDisplay-modalContents-target'
  const MODAL_CONTENTS_TARGET_SELECTOR = `.${MODAL_CONTENTS_TARGET_CLASS_NAME}`

  // 処理
  const $rootElement = $(ROOT_TARGET_SELECTOR)

  // スクロール無効処理
  const disableScroll = (event) => { event.preventDefault() }

  $rootElement.each((index, root) => {
    const $openTrigger = $(root).find(OPEN_TRIGGER_SELECTOR)
    const $closeTrigger = $(root).find(CLOSE_TRIGGER_SELECTOR)
    const $switchOverlayTarget = $(root).find(MODAL_OVERLAY_TARGET_SELECTOR)
    const $switchContentsTarget = $(root).find(MODAL_CONTENTS_TARGET_SELECTOR)

    $openTrigger.on('click', () => {
      // スクロール無効
      window.addEventListener('touchmove', disableScroll, { passive: false })
      window.addEventListener('wheel', disableScroll, { passive: false })

      // 要素表示
      $switchOverlayTarget.show()
      $switchContentsTarget.show().css({ bottom: `-${$switchContentsTarget.height()}px` }).animate({ bottom: 0 }, 400)
    })

    $closeTrigger.on('click', () => {
      // スクロール無効を解除
      window.removeEventListener('touchmove', disableScroll)
      window.removeEventListener('wheel', disableScroll)

      // 要素表示
      $switchOverlayTarget.hide()
      $switchContentsTarget.hide()
      $switchContentsTarget.css({ bottom: '' })
    })
  })
}

$(() => {
  // submitボタンの活性化処理
  activateSubmit()

  // 市区町村の更新処理
  updateCity()

  // 都道府県がある場合、市区町村の初期値を設定
  if (gon.prefecture_id) {
    setCities()
  }

  // 検索ウィジェットの表示・非表示切り替え
  switchSearchWidgetDisplay()
})
